<div class="dashboard-container w-full max-w-320 mx-auto p-4 lg:p-8">

    <!-- Header -->
    <div class="flex items-center justify-between mb-2">
        <h1 class="text-2xl font-semibold text-gray-900 dark:text-white">Pulpit</h1>
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-12 gap-8">

        <!-- Main Content Column -->
        <div class="lg:col-span-8 space-y-6">

            <!-- Announcements -->
            <announcements-list></announcements-list>

            <!-- KSeF Setup Alert -->
            <app-ksef-setup-alert></app-ksef-setup-alert>

            <!-- Income Chart Card -->
            <div class="chart-card bg-card rounded-2xl border border-gray-200 dark:border-slate-700">
                <div class="p-6">
                    <div class="flex items-center justify-between mb-6">
                        <div>
                            <h2 class="text-xl font-semibold text-gray-900 dark:text-white">Analiza finansów</h2>
                            <p class="text-sm text-gray-500 dark:text-gray-400 mt-0.5">Przegląd przychodów i kosztów</p>
                        </div>
                    </div>
                    <income-chart></income-chart>
                </div>
            </div>
            
            <!-- Income/Expense Tabs Card -->
            <div class="transactions-card bg-card rounded-2xl border border-gray-200 dark:border-slate-700">
                <div class="p-6">
                    <div class="flex items-center justify-between mb-6">
                        <div>
                            <h2 class="text-xl font-semibold text-gray-900 dark:text-white">Historia transakcji</h2>
                            <p class="text-sm text-gray-500 dark:text-gray-400 mt-0.5">Twoje ostatnie dokumenty</p>
                        </div>
                    </div>
                    <income-expense-tabs></income-expense-tabs>
                </div>
            </div>

        </div>

        <!-- Sidebar Column -->
        <div class="lg:col-span-4 space-y-6">

            <!-- Quick Actions Card -->
            <div class="quick-actions-card bg-card rounded-2xl border border-gray-200 dark:border-slate-700 p-5 mt-6">
                <h3 class="text-base font-semibold text-gray-900 dark:text-white mb-3">
                    Szybkie akcje
                </h3>
                <div class="space-y-1">
                    <a [routerLink]="'/konto/dokumenty/wystaw'" 
                       class="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-50 dark:hover:bg-slate-800 transition-colors group cursor-pointer">
                        <div class="h-9 w-9 rounded-lg bg-gray-100 dark:bg-slate-800 flex items-center justify-center">
                            <mat-icon [svgIcon]="'tabler_outline:file-plus'" class="text-gray-600 dark:text-gray-400 h-5 w-5"></mat-icon>
                        </div>
                        <div class="flex-1">
                            <div class="font-medium text-sm text-gray-900 dark:text-white">Wystaw dokument</div>
                        </div>
                        <mat-icon [svgIcon]="'tabler_outline:chevron-right'" class="text-gray-400 h-4 w-4"></mat-icon>
                    </a>
                    <button (click)="showPrintManyDialog()" 
                            class="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-50 dark:hover:bg-slate-800 transition-colors group cursor-pointer w-full text-left">
                        <div class="h-9 w-9 rounded-lg bg-gray-100 dark:bg-slate-800 flex items-center justify-center">
                            <mat-icon [svgIcon]="'tabler_outline:download'" class="text-gray-600 dark:text-gray-400 h-5 w-5"></mat-icon>
                        </div>
                        <div class="flex-1">
                            <div class="font-medium text-sm text-gray-900 dark:text-white">Pobierz wiele faktur</div>
                        </div>
                        <mat-icon [svgIcon]="'tabler_outline:chevron-right'" class="text-gray-400 h-4 w-4"></mat-icon>
                    </button>
                    <a [routerLink]="'/konto/produkty/utworz'" 
                       class="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-50 dark:hover:bg-slate-800 transition-colors group cursor-pointer">
                        <div class="h-9 w-9 rounded-lg bg-gray-100 dark:bg-slate-800 flex items-center justify-center">
                            <mat-icon [svgIcon]="'tabler_outline:package'" class="text-gray-600 dark:text-gray-400 h-5 w-5"></mat-icon>
                        </div>
                        <div class="flex-1">
                            <div class="font-medium text-sm text-gray-900 dark:text-white">Dodaj produkt</div>
                        </div>
                        <mat-icon [svgIcon]="'tabler_outline:chevron-right'" class="text-gray-400 h-4 w-4"></mat-icon>
                    </a>
                </div>
            </div>

            <!-- Stats Cards -->
            <!-- <div class="grid grid-cols-2 gap-3">
                <div class="stat-card bg-card rounded-xl p-4 border border-gray-200 dark:border-slate-700">
                    <div class="flex items-center gap-2 mb-2">
                        <mat-icon [svgIcon]="'tabler_outline:trending-up'" class="h-5 w-5 text-emerald-600 dark:text-emerald-400"></mat-icon>
                        <span class="text-xs text-gray-500 dark:text-gray-400">Przychody</span>
                    </div>
                    <div class="text-2xl font-semibold text-gray-900 dark:text-white">{{incomeCount || 0}}</div>
                </div>
                <div class="stat-card bg-card rounded-xl p-4 border border-gray-200 dark:border-slate-700">
                    <div class="flex items-center gap-2 mb-2">
                        <mat-icon [svgIcon]="'tabler_outline:trending-down'" class="h-5 w-5 text-rose-600 dark:text-rose-400"></mat-icon>
                        <span class="text-xs text-gray-500 dark:text-gray-400">Koszty</span>
                    </div>
                    <div class="text-2xl font-semibold text-gray-900 dark:text-white">{{expenseCount || 0}}</div>
                </div>
            </div> -->

            <!-- Guided Tour Card -->
            <div (click)="startTour()" class="knowledge-card group bg-card rounded-xl border border-gray-200 dark:border-slate-700 hover:border-gray-300 dark:hover:border-slate-600 transition-colors cursor-pointer">
                <div class="p-4">
                    <div class="flex items-center gap-3">
                        <div class="h-10 w-10 rounded-lg bg-gray-100 dark:bg-slate-800 flex items-center justify-center">
                            <mat-icon [svgIcon]="'tabler_outline:compass'" class="text-gray-600 dark:text-gray-400 h-5 w-5"></mat-icon>
                        </div>
                        <div class="flex-1">
                            <h3 class="font-medium text-gray-900 dark:text-white">Przewodnik</h3>
                            <p class="text-gray-500 dark:text-gray-400 text-xs">Przewodnik po systemie</p>
                        </div>
                        <mat-icon [svgIcon]="'tabler_outline:chevron-right'" class="text-gray-400 h-4 w-4"></mat-icon>
                    </div>
                </div>
            </div>

            <!-- Knowledge Base Card -->
            <a href="https://pomoc.fakturnia.pl" target="_blank" class="block">
                <div class="knowledge-card group bg-card rounded-xl border border-gray-200 dark:border-slate-700 hover:border-gray-300 dark:hover:border-slate-600 transition-colors cursor-pointer">
                    <div class="p-4">
                        <div class="flex items-center gap-3">
                            <div class="h-10 w-10 rounded-lg bg-gray-100 dark:bg-slate-800 flex items-center justify-center">
                                <mat-icon [svgIcon]="'tabler_outline:book'" class="text-gray-600 dark:text-gray-400 h-5 w-5"></mat-icon>
                            </div>
                            <div class="flex-1">
                                <h3 class="font-medium text-gray-900 dark:text-white">Baza wiedzy</h3>
                                <p class="text-gray-500 dark:text-gray-400 text-xs">Poradniki i odpowiedzi</p>
                            </div>
                            <mat-icon [svgIcon]="'tabler_outline:chevron-right'" class="text-gray-400 h-4 w-4"></mat-icon>
                        </div>
                    </div>
                </div>
            </a>

            <!-- Support Card -->
            <a href="mailto:kontakt@fakturnia.pl?subject=Potrzebuje%20pomocy" class="block">
                <div class="knowledge-card group bg-card rounded-xl border border-gray-200 dark:border-slate-700 hover:border-gray-300 dark:hover:border-slate-600 transition-colors cursor-pointer">
                    <div class="p-4">
                        <div class="flex items-center gap-3">
                            <div class="h-10 w-10 rounded-lg bg-gray-100 dark:bg-slate-800 flex items-center justify-center">
                                <mat-icon [svgIcon]="'tabler_outline:headset'" class="text-gray-600 dark:text-gray-400 h-5 w-5"></mat-icon>
                            </div>
                            <div class="flex-1">
                                <h3 class="font-medium text-gray-900 dark:text-white">Potrzebujesz pomocy?</h3>
                                <p class="text-gray-500 dark:text-gray-400 text-xs">Napisz do nas — chętnie pomożemy</p>
                            </div>
                            <mat-icon [svgIcon]="'tabler_outline:chevron-right'" class="text-gray-400 h-4 w-4"></mat-icon>
                        </div>
                    </div>
                </div>
            </a>

            <!-- Mobile Apps -->
            <div class="apps-card bg-card rounded-xl border border-gray-200 dark:border-slate-700 p-4">
                <div class="flex items-center gap-3 mb-4">
                    <div class="h-10 w-10 rounded-lg bg-gray-100 dark:bg-slate-800 flex items-center justify-center flex-shrink-0">
                        <mat-icon [svgIcon]="'tabler_outline:device-mobile'" class="text-gray-600 dark:text-gray-400"></mat-icon>
                    </div>
                    <div>
                        <h3 class="font-medium text-gray-900 dark:text-white">Aplikacje mobilne</h3>
                        <p class="text-gray-500 dark:text-gray-400 text-xs">Zarządzaj dokumentami z telefonu</p>
                    </div>
                </div>
                <div class="flex gap-2">
                    <a href="https://apps.apple.com/pl/app/fakturnia-pl-wystaw-faktury/id6746215170" target="_blank" 
                       class="flex-1 flex items-center justify-center gap-2 p-2.5 rounded-lg border border-gray-200 dark:border-slate-700 hover:bg-gray-50 dark:hover:bg-slate-800 transition-colors">
                        <mat-icon [svgIcon]="'tabler_outline:brand-apple'" class="!w-5 !h-5 text-gray-700 dark:text-gray-300"></mat-icon>
                        <span class="text-xs font-medium text-gray-700 dark:text-gray-300">App Store</span>
                    </a>
                    <a href="https://play.google.com/store/apps/details?id=io.fakturnia.mobile" target="_blank" 
                       class="flex-1 flex items-center justify-center gap-2 p-2.5 rounded-lg border border-gray-200 dark:border-slate-700 hover:bg-gray-50 dark:hover:bg-slate-800 transition-colors">
                        <mat-icon [svgIcon]="'tabler_outline:brand-google-play'" class="!w-5 !h-5 text-gray-700 dark:text-gray-300"></mat-icon>
                        <span class="text-xs font-medium text-gray-700 dark:text-gray-300">Google Play</span>
                    </a>
                </div>
            </div>

        </div>
    </div>
</div>